import React, { useState } from 'react'
// import ReactDOM from 'react-dom'
import { compose } from 'recompose'
// import Script from 'react-load-script'
import { Button, message, Modal } from 'antd'
import { injectIntl, FormattedMessage } from 'react-intl'
import { graphql } from 'react-apollo'
import _get from 'lodash/get'
// import _entries from 'lodash/entries'
import QRCode from 'qrcode'
// import moment from 'moment'
import payRegistrationMutation from '~/App/graphql/mutations/payRegistration.gql'
// import TransferModal from './TransferModal'
import { Block } from '../styles'
// import { inject, observer } from 'mobx-react'
const ScbQr = compose(
  // inject('i18n'),
  injectIntl,
  graphql(payRegistrationMutation, {
    name: 'payRegistration'
  })
  // observer
)(({ intl, registration, payRegistration, discounted, gatewayRate, gatewaySettings, systemFee, totalSystemFee, itemsDiscounted, bankAccountInfo }) => {
  // const totalAmount = discounted + itemsDiscounted
  // const fee = Math.round(gatewayRate * discounted * 100) / 100
  const [paymentLoading, setPaymentLoading] = useState(false)

  const handleCheckout = async () => {
    setPaymentLoading(true)
    try {
      const { data } = await payRegistration({
        variables: {
          record: {
            registrationId: registration._id,
            eventId: registration.eventId,
            method: 'scb_qr',
            data: {
              scb: {
                completeRedirect: `${process.env
                  .REACT_APP_BASE_URI}/reg/${registration._id}`
              }
            }
          }
        }
      })
      const source = _get(
        data,
        'payRegistration.record.data.scb.invoice.source'
      )
      // console.log(source, source.split('\r'))
      if (source) {
        const qrCode = await QRCode.toDataURL(source, { scale: 8 })
        Modal.confirm({
          content: <img src={qrCode} alt="PromptPay QR" />
        })
      }
    } catch (err) {
      const { graphQLErrors } = err
      if (graphQLErrors) {
        graphQLErrors.forEach(error => {
          message.error(intl.formatMessage({ id: `api.${error.message}` }))
        })
      } else {
        message.error(err.message)
      }
    } finally {
      setPaymentLoading(false)
    }
  }

  return <Block>
    <div className="title">
      <FormattedMessage id="paymentMethod.scb_qr" />
    </div>
    <div>
      {systemFee
        ? <React.Fragment>
          <FormattedMessage id="app.entryFeeBaht" defaultMessage="Entry Fee {amount} Baht" tagName="div" values={{
            amount: intl.formatNumber(discounted - totalSystemFee)
          }} />
          <FormattedMessage id="app.processingFeeBaht" defaultMessage="Processing Fee {amount} Baht" tagName="div" values={{
            amount: intl.formatNumber(totalSystemFee)
          }} />
        </React.Fragment>
        : <FormattedMessage id="app.entryFeeBaht" defaultMessage="Entry Fee {amount} Baht" tagName="div" values={{
          amount: intl.formatNumber(discounted)
        }} />
      }
      {/* <FormattedMessage id="app.paymentProcessingFeeBaht" defaultMessage="Processing Fee" values={{
        amount: intl.formatNumber(fee)
      }} /> */}
      {itemsDiscounted > 0 && <FormattedMessage id="app.itemsAmountBaht" defaultMessage="Extra Products {amount} Baht" tagName="div" values={{
        amount: intl.formatNumber(itemsDiscounted)
      }} />}
    </div>
    <Button
      icon="qrcode"
      type="primary"
      onClick={() => handleCheckout()}
      loading={paymentLoading}
      className="paymentButton"
    >
      <FormattedMessage id="paymentMethod.showQrCode" />
    </Button>
  </Block>
})

export default ScbQr



// WEBPACK FOOTER //
// ./src/App/components/PaymentBlocks/ScbQr/ScbQr.js